import { Injectable } from '@angular/core';
import { NotificationComponent } from './components/notification/notification.component';

import { MatSnackBar } from '@angular/material/snack-bar';

@Injectable({
  providedIn: 'root'
})
export class NotificationService {

  constructor(private snackbar: MatSnackBar) { } 

  error(message: string): void {
    this.snackbar.openFromComponent(NotificationComponent, {
      duration: 5000,
      data: { message },
      panelClass: ['mat-snackbar_error']
    });
  }

  success(message: string): void {
    this.snackbar.openFromComponent(NotificationComponent, {
      duration: 5000,
      data: { message },
      panelClass: ['mat-snackbar_success'] 
    });
  }
}
